import React, {Component, ReactElement} from 'react'
import NatResidentStaticContentsComponent from '../common/resident/NatResidentStaticContentsComponent'
import {Nullable} from '../../../app/TypeHelpers';
import {NavigateFunction} from 'react-router-dom'
import {HKConstants} from '../../../HKConstants';


interface Props {
    contents: string
    navigate: NavigateFunction,
}


interface States {
    resource: string,
    resourceHaseko: string,
    resourcePolicy: string,
    resourceSuteki: string,
    resourceBrc: string,
}

class NatResidentStaticContentsPage extends Component<Props, States> {
    constructor(props: Props) {
        super(props);
        this.state = {
            resource: '',
            resourceHaseko: '',
            resourcePolicy: '',
            resourceSuteki: '',
            resourceBrc: '',
        };
    }

    componentDidMount(): void {
        let title: string = ``;
        let resource: string = ``;
        let resourceHaseko: string = ``;
        let resourcePolicy: string = ``;
        let resourceSuteki: string = ``;
        let resourceBrc: string = ``;

        // 静的コンテンツ　利用判定
        switch (this.props.contents) {
            case 'wakuwakuMaintenance':
                title = 'わくわくメンテナンス | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance.html`;
                break;
            case 'wakuwakuMaintenance_entrance':
                title = 'わくわくメンテナンス 玄関 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_entrance.html`;
                break;
            case 'wakuwakuMaintenance_entrance-detail':
                title = 'わくわくメンテナンス 玄関 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_entrance-detail.html`;
                break;
            case 'wakuwakuMaintenance_living_dining':
                title = 'わくわくメンテナンス リビングダイニング | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_living_dining.html`;
                break;
            case 'wakuwakuMaintenance_living_dining-detail':
                title = 'わくわくメンテナンス リビングダイニング - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_living_dining-detail.html`;
                break;
            case 'wakuwakuMaintenance_balcony':
                title = 'わくわくメンテナンス ベランダ | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_balcony.html`;
                break;
            case 'wakuwakuMaintenance_balcony-detail':
                title = 'わくわくメンテナンス ベランダ - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_balcony-detail.html`;
                break;
            case 'wakuwakuMaintenance_kitchen':
                title = 'わくわくメンテナンス キッチン | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_kitchen.html`;
                break;
            case 'wakuwakuMaintenance_kitchen-detail':
                title = 'わくわくメンテナンス キッチン - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_kitchen-detail.html`;
                break;
            case 'wakuwakuMaintenance_bedroom':
                title = 'わくわくメンテナンス 洋室 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_bedroom.html`;
                break;
            case 'wakuwakuMaintenance_bedroom-detail':
                title = 'わくわくメンテナンス 洋室 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_bedroom-detail.html`;
                break;
            case 'wakuwakuMaintenance_japanese_room':
                title = 'わくわくメンテナンス 和室 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_japanese_room.html`;
                break;
            case 'wakuwakuMaintenance_japanese_room-detail':
                title = 'わくわくメンテナンス 和室 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_japanese_room-detail.html`;
                break;
            case 'wakuwakuMaintenance_washroom':
                title = 'わくわくメンテナンス 洗面室 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_washroom.html`;
                break;
            case 'wakuwakuMaintenance_washroom-detail':
                title = 'わくわくメンテナンス 洗面室 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_washroom-detail.html`;
                break;
            case 'wakuwakuMaintenance_bathroom':
                title = 'わくわくメンテナンス 浴室 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_bathroom.html`;
                break;
            case 'wakuwakuMaintenance_bathroom-detail':
                title = 'わくわくメンテナンス 浴室 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_bathroom-detail.html`;
                break;
            case 'wakuwakuMaintenance_restroom':
                title = 'わくわくメンテナンス トイレ | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_restroom.html`;
                break;
            case 'wakuwakuMaintenance_restroom-detail':
                title = 'わくわくメンテナンス トイレ - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_restroom-detail.html`;
                break;
            case 'wakuwakuMaintenance_heater':
                title = 'わくわくメンテナンス 熱源 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_heater.html`;
                break;
            case 'wakuwakuMaintenance_heater-detail':
                title = 'わくわくメンテナンス 熱源 - 詳細 | 素敵ネット';
                resource = `/resources/contents/wakuwakuMaintenance/wakuwakuMaintenance_heater-detail.html`;
                break;
            case 'policyTerms':
                title = '利用規約 | 素敵ネット';
                resource = `/resources/contents/policy/terms_head.html`;
                resourceSuteki= `/resources/contents/policy/`+HKConstants.VMN.NTF.TERMS_FILENAME_SUTEKI;
                resourceHaseko = `/resources/contents/policy/`+HKConstants.VMN.NTF.TERMS_FILENAME_HASEKO_PRIVACY;
                resourcePolicy= `/resources/contents/policy/`+HKConstants.VMN.NTF.TERMS_FILENAME_PRIVACY_POLICY;
                resourceBrc= `/resources/contents/policy/`+HKConstants.VMN.NTF.TERMS_FILENAME_BRANCIELA;
                break;
            default:
                break;
        }
        // タイトルタグ
        document.title = title;
        // 静的コンテンツ
        this.setState({
            resource: resource,
            resourceHaseko: resourceHaseko,
            resourcePolicy: resourcePolicy,
            resourceSuteki: resourceSuteki,
            resourceBrc: resourceBrc
        })
    }


    render(): Nullable<ReactElement> {
        const {contents} = this.props;
        if (this.state.resource === '') {
            return null
        } else if (contents === 'policyTerms') {
            return (
                <>
                    <NatResidentStaticContentsComponent contents={this.state.resource}/>
                    <NatResidentStaticContentsComponent contents={this.state.resourceSuteki}/>
                    <NatResidentStaticContentsComponent contents={this.state.resourceHaseko}/>
                    <NatResidentStaticContentsComponent contents={this.state.resourcePolicy}/>
                    <NatResidentStaticContentsComponent contents={this.state.resourceBrc}/>
                </>
            )
        } else {
            return (
                <>
                    <NatResidentStaticContentsComponent contents={this.state.resource}/>
                </>
            )
        }
    }
}

export default NatResidentStaticContentsPage

